import { Component, OnDestroy, ViewChild } from "@angular/core";
import { ActivatedRoute, Router }          from "@angular/router";
import { DataProvider } from "../../services/data/data";
import { Subscription } from "rxjs";
import { Node } from "../../../_model";
import { IsoCode } from "../../../_model/Language";
import { PHBGlobals } from "../../../_config/config";

@Component({
	selector: "app-search-result",
	templateUrl: "./search-result.component.html",
	styleUrls: ["./search-result.component.scss"]
})
export class SearchResultComponent implements OnDestroy{

	@ViewChild("pageTop") pageTop;
	currentNode: Node = null;

	displayType: string = null;

	private subscription: Subscription;

	_isoCode: IsoCode = null;

	get isoCode(): IsoCode {
		return this._isoCode;
	}

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private dataProvider: DataProvider
	) {
		this.subscription = this.route.params.subscribe(async (params) => {
			this.update(params.id,params.isoCode);
		});

	}

	async update(id: string, isoCode: IsoCode = null) {
		try {
			this.currentNode = await this.dataProvider.getNode(id);
			if (isoCode && this.currentNode.translations.hasOwnProperty(isoCode)) {
				this._isoCode = isoCode;
			} else {
				[isoCode] = this.currentNode.getTranslation(PHBGlobals.currentLanguage);
				this._isoCode = isoCode;
			}
		} catch (e) {
			await this.router.navigate(["/home"]);
			return;
		}
	}

	ngOnDestroy() {
		console.log("destroy");
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

}
